module.exports = __webpack_public_path__ + "assets/img/E-f87507d9.png";